import { RefundStatusType } from "@/types/graphql/partner.generated";

const STATUS_KEY: Record<RefundStatusType, string> = {
  [RefundStatusType.PendingType]: "pending",
  [RefundStatusType.SucceededType]: "succeeded",
  [RefundStatusType.FailedType]: "failed",
};

export interface RefundStatusLike {
  status: RefundStatusType;
  manual: boolean;
}

/**
 * Подпись статуса возврата для CSV и чипа. Ручной возврат (учтён только у
 * нас, провайдер его не получал) показывается отдельно от «Выполнен»:
 * иначе партнёр не отличит его от возврата, деньги по которому уже ушли.
 */
export const refundStatusLabelKey = (refund: RefundStatusLike): string =>
  refund.manual
    ? "refunds.status.manual"
    : `refunds.status.${STATUS_KEY[refund.status]}`;
